import { createSlice } from '@reduxjs/toolkit';

import { CalendarPlanShowcaseStore } from './typings';

const initialState: CalendarPlanShowcaseStore = {
    isCalendarPlanOpened: false,
};

const { actions, reducer } = createSlice({
    name: 'CALENDAR_PLAN_SHOWCASE',
    initialState: initialState,
    reducers: {
        openCalendarPlan: (state) => {
            state.isCalendarPlanOpened = true;
        },
        closeCalendarPlan: (state) => {
            state.isCalendarPlanOpened = false;
        },
    },
});

export const calendarPlanShowcaseActions = actions;
export const calendarPlanShowcaseReducer = reducer;
